import { render, staticRenderFns } from "./TeamCode.vue?vue&type=template&id=0c5b9d27&scoped=true"
import script from "./TeamCode.vue?vue&type=script&lang=js"
export * from "./TeamCode.vue?vue&type=script&lang=js"
import style0 from "./TeamCode.vue?vue&type=style&index=0&id=0c5b9d27&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../2026-08-26/github-cli-gh-codex/work/jiangkv3/web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c5b9d27",
  null
  
)

export default component.exports